import Hammer from "hammerjs"
import events from "@/bl-events"

class Slider {
  constructor(node) {
    this.container = node
    this.id = this.container.dataset.slider || "slider"
    this.timeout = this.container.dataset.sliderTimeout
    this.leaveClassnames = ["slider__item--leave"]
    this.activeClassnames = ["slider__item--active"]
    this.animationDuration = 250
    this.slides = this.container.querySelectorAll(".slider__item")
    this.controls = this.container.querySelectorAll(".slider__control")
    this.next = this.container.querySelector(".slider__next")
    this.previous = this.container.querySelector(".slider__previous")
    this.eventName = this.container.dataset.sliderEvent
    this.timer = true
    this.currentIndex = 0
    this.isAnimating = false

    if (this.id) {
      this.leaveClassnames.push(`${this.id}-item--leave`)
      this.activeClassnames.push(`${this.id}-item--active`)
    }

    this.initEvents()
    this.initSwipe()
    this.go(this.currentIndex)
  }

  initEvents() {
    // Controls events
    for (let i = 0; i < this.controls.length; i++) {
      this.controls[i].addEventListener("click", () => {
        clearTimeout(this.timer)
        this.timer = null
        this.go(i)
        if (this.eventName) {
          events.track([this.eventName, "1-click"])
        }
      })
      this.controls[i].addEventListener("mouseover", () => {
        this.controls[i].classList.add("slider__control--active")
      })
      this.controls[i].addEventListener("mouseout", () => {
        if (this.currentIndex !== i) {
          this.controls[i].classList.remove("slider__control--active")
        }
      })
    }

    // Next button
    if (this.next) {
      this.next.addEventListener("click", () => {
        if (this.currentIndex < this.slides.length - 1) {
          this.go(this.getNextIndex())
        }
      })
    }

    // Previous button
    if (this.previous) {
      this.previous.addEventListener("click", () => {
        if (this.currentIndex > 0) {
          this.go(this.getPreviousIndex())
        }
      })
    }
  }

  go(index) {
    if (this.isAnimating) {
      return
    }

    const currentSlide = this.container.querySelector(`.${this.activeClassnames[0]}`)

    if (!this.slides[index]) {
      return
    }

    if (currentSlide) {
      this.animateLeave(
        currentSlide,
        function () {
          this.animateEnter(this.slides[index])
        }.bind(this)
      )
    } else {
      this.animateEnter(this.slides[index])
    }

    const currentControls = this.container.querySelectorAll(".slider__control--active")
    for (let i = 0; i < currentControls.length; i++) {
      currentControls[i].classList.remove("slider__control--active")
    }

    if (this.controls[index]) {
      this.controls[index].classList.add("slider__control--active")
    }

    this.currentIndex = index
    this.isAnimating = true

    if (this.next) {
      const nextClassAction = this.currentIndex < this.slides.length - 1 ? "add" : "remove"
      this.next.classList[nextClassAction]("slider__next--active")
    }
    if (this.previous) {
      const previousClassAction = this.currentIndex > 0 ? "add" : "remove"
      this.previous.classList[previousClassAction]("slider__previous--active")
    }
  }

  timeoutNext() {
    if (!this.timeout) {
      return
    }

    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.go(this.getNextIndex())
    }, this.timeout)
  }

  animateEnter(slide, next) {
    slide.classList.add.apply(slide.classList, this.activeClassnames)
    setTimeout(() => {
      this.isAnimating = false
      this.timeoutNext()
      if (next) {
        next()
      }
    }, this.animationDuration)
  }

  animateLeave(slide, next) {
    slide.classList.add.apply(slide.classList, this.leaveClassnames)
    setTimeout(() => {
      slide.classList.remove.apply(slide.classList, this.activeClassnames)
      slide.classList.remove.apply(slide.classList, this.leaveClassnames)
      if (next) {
        next()
      }
    }, this.animationDuration)
  }

  initSwipe() {
    const mc = new Hammer(this.container)
    mc.on("swipeleft", () => {
      clearTimeout(this.timer)
      this.go(this.getNextIndex())
      if (this.eventName) {
        events.track([this.eventName, "1-swipe"])
      }
    })
    mc.on("swiperight", () => {
      clearTimeout(this.timer)
      this.go(this.getPreviousIndex())
      if (this.eventName) {
        events.track([this.eventName, "1-swipe"])
      }
    })
  }

  getNextIndex() {
    let next = this.currentIndex + 1
    if (next >= this.slides.length) {
      next = 0
    }
    return next
  }

  getPreviousIndex() {
    let previous = this.currentIndex - 1
    if (previous < 0) {
      previous = this.slides.length - 1
    }
    return previous
  }
}

const initSliders = () => {
  const sliders = []
  const nodes = document.querySelectorAll(".slider")
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i]
    if (sliders[node]) {
      continue
    }
    new Slider(node)
    sliders.push(node)
  }
}

initSliders()

export default Slider
